import { motion } from 'motion/react'
import { SVGProps } from 'react'

interface AnimatedIconProps extends SVGProps<SVGSVGElement> {
	isActive?: boolean
}

export default function AnimatedPersonalIcon({ isActive, ...props }: AnimatedIconProps) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<motion.path
					d="M18.8284 18.1716C19.3405 18.6837 19.6994 19.3203 19.8757 20.0104C20.0123 20.5455 19.5523 21 19 21H5C4.44772 21 3.98769 20.5455 4.12435 20.0104C4.30056 19.3203 4.65947 18.6837 5.17157 18.1716C5.92172 17.4214 6.93913 17 8 17H16C17.0609 17 18.0783 17.4214 18.8284 18.1716Z"
					fill="none"
					stroke="var(--tint-primary)"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
					animate={{
						fill: isActive ? 'var(--tint-primary)' : 'rgba(0, 0, 0, 0)',
					}}
					transition={{
						duration: 0.2,
					}}
				/>
				<motion.path
					d="M12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13Z"
					fill="none"
					stroke="var(--tint-primary)"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
					animate={{
						fill: isActive ? 'var(--tint-primary)' : 'rgba(0, 0, 0, 0)',
					}}
					transition={{
						duration: 0.2,
					}}
				/>
			</g>
		</svg>
	)
}
